import React, { PureComponent } from 'react';
import '@atlaskit/css-reset';
import Page from '@atlaskit/page';

import RegistryNavigation from '../components/RegistryNavigation';

export default class App extends PureComponent {

  state = {
    isSearchDrawerOpen: false,
    navigationWidth: 304,
    isNavigationOpen: true,
  }

  onNavResize = ({ width, isOpen }) => {
    this.setState({
      navigationWidth: width,
      isNavigationOpen: isOpen,
    });
  }

  onSearchDrawerToggle = (isSearchDrawerOpen) => {
    this.setState({ isSearchDrawerOpen });
  }

  render() {
    return (
      <Page
        navigationWidth={this.state.navigationWidth}
        navigation={
          <RegistryNavigation
            isNavigationOpen={this.props.isNavigationOpen}
            isSearchDrawerOpen={this.state.isSearchDrawerOpen}
            onNavResize={this.onNavResize}
            onSearchDrawerToggle={this.onSearchDrawerToggle}
            navigationWidth={this.props.navigationWidth}
          />
        }
      >
        {this.props.children}
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/App.jsx